import { initInstallSlider } from './control-installation-install/control-installation-install';
import YTPlayer from '../../scripts/components/YTPlayer';
import { initCollapsibleRows } from '../../snippets/collapsible-rows/collapsible-rows';

initInstallSlider();
initCollapsibleRows();
YTPlayer.init();
